// extracted by mini-css-extract-plugin
module.exports = {"main":"moods_main__3jc78","image":"moods_image__1VwoQ","disc":"moods_disc__1RWgl"};